import React from 'react'
import './ClientCase.scss'
import Image from './Image/Image'
import Text from './Text/Text'
import Cta from './CTA/CTA'

const ClientCase = ({content, related}) => {

	const renderBlocks = () => {
		return content.map((block, i) => {
			switch(block.fieldGroupName) {
				case 'clientCase_Casecontent_Content_Image':
					return <Image id={i} key={`${block.fieldGroupName}_${i}`} {...block} />

				case 'clientCase_Casecontent_Content_Text':
					return <Text id={i} key={`${block.fieldGroupName}_${i}`} {...block} related={related} />

				case 'clientCase_Casecontent_Content_Cta':
					return <Cta id={i} key={`${block.fieldGroupName}_${i}`} {...block} />

				default:
					return null
			}
		})
	}

	return (
		<>
			{ renderBlocks() }
		</>
	)
}

export default ClientCase